module.exports = __webpack_public_path__ + "img/peixun.b201dfb9.png";